import {ViewStyle} from 'react-native';
import {UserInfo} from '../../types';
import React from 'react';
import {Avatar} from 'react-native-paper';

export const SettingsAvatar = (props: {
  style: ViewStyle;
  UserData: UserInfo | undefined;
  AvatarSize: number;
}) => {
  // return UserData?.photo ? (
  //   <Avatar.Image
  //     style={props.style}
  //     source={{
  //       uri: UserData?.photo,
  //       cache: 'force-cache',
  //     }}
  //     size={AvatarSize}
  //   />
  // ) : (
  return (
    <Avatar.Text
      style={props.style}
      label={
        (props.UserData?.name &&
          props.UserData?.name
            .split(' ')
            .map(i => i[0])
            .join('')) ||
        ''
      }
      size={props.AvatarSize}
    />
  );
  // );
};
